import React, { Component, Fragment } from "react";
import { Row, Col, Container, Image } from "react-bootstrap";

import styles from "./Products.module.scss";

import AgriFreshSpray from "../../assets/png/AgriFreshSpray.png";
import AgriCarbonBottle from "../../assets/png/AgriCarbonBottle.png";
import AgriFreshPouch from "../../assets/png/AgriFreshPouch.png";

export default class Products extends Component {
  render() {
    return (
      <section id={styles.Products}>
        <Container id="OurProducts" fluid>
          <Row>
            <Col lg={7} className={styles.containerTop}>
              <div className={styles.vl}></div>
              <div id={styles.Box1}>
                <p id={styles.Heading}>
                  Our<br></br> Products
                </p>
                <br></br>
                <p id={styles.SubHeading}>
                  LIFESTYLE ESSENTIALS MADE BETTER
                  <sup className={styles.sup}>TM</sup>
                </p>
                <br></br>
                <p id={styles.Content}>
                  Agrinol delivers{" "}
                  <b>
                    <i>100% natural, scientifically-proven</i>
                  </b>{" "}
                  products that improve your daily life while{" "}
                  <b>reversing your carbon footprint.</b> From the air you
                  breathe and food you eat to the plants you grow and car you
                  drive—Agrinol has you covered.
                </p>
                <br></br>
                <p id={styles.PatentPending}>*Patent pending.</p>
              </div>
              <div id={styles.Box2}>
                <figure>
                  <Image
                    src={AgriCarbonBottle}
                    id={styles.AgriCarbonBottle}
                  ></Image>
                  <figcaption className={styles.figcaption}>
                    <div className={styles.hl}></div>
                    <div id={styles.TextPlantCare}>Plant Care</div>
                    <div className={styles.hl}></div>
                  </figcaption>
                  <br></br>
                  <figcaption id={styles.TextBox1}>
                    Revolutionize your garden.{" "}
                    <b>
                      <i>AgriCarbon</i>
                    </b>{" "}
                    naturally{" "}
                    <b>
                      converts carbon dioxide into vital plant nutrients, while
                      recycling coffee waste.
                    </b>
                  </figcaption>
                </figure>
              </div>
            </Col>

            <Col lg={5} className={styles.containerBottom}>
              <figure>
                <div id={styles.ImageAlign}>
                  <Image
                    src={AgriFreshPouch}
                    id={styles.AgriFreshPouch}
                  ></Image>
                  <Image
                    src={AgriFreshSpray}
                    id={styles.AgriFreshSpray}
                  ></Image>
                </div>
                <figcaption className={styles.figcaption}>
                  <div className={styles.hl}></div>
                  <div id={styles.TextProduceCare}>Produce Care</div>
                  <div className={styles.hl}></div>
                </figcaption>
                <br></br>
                <figcaption id={styles.TextBox2}>
                  Spoiled produce no more. By absorbing greenhouse gases that
                  cause bacteria to grow on fruits and vegetables,{" "}
                  <b>
                    <i>AgriFresh</i> naturally extends produce shelf life by up
                    to 5x.
                  </b>
                  {/* <br></br>{" "}
                  <span id={styles.SmallText}>
                    *Approved for use in foods under the Food and Drug
                    Regulations [Section B.16.100].
                  </span>  */}
                </figcaption>
              </figure>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}
